<template>
  <div class="FormView">
    <FromComm :FromArr="FromArr" @distributorChange="distributorChange" @invClassChange="invClassChange" @LargeArea="LargeArea" @ThirdDealerChange="ThirdDealerChange"></FromComm>
    <div :style="[ `right: ${right}px` ]" class="btngroup">
      <CommonBtngroup ref="btngroup" :qhide="false" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
    </div>

    <DialogFrom width="800px" title="选择经销商" :dialogVisible="dialogVisibDialog" @cancel="cancelDialog" @dialogOK="dialogOKDialog">
      <div class="DialogFrom">
        <div class="search">
          <SearchComm placeholder="输入经销商名称" @searchClick="searchClick" :width="590"></SearchComm>
        </div>
        <div class="table">
          <Commontable @handleSelectionChange="handleSelectionChange" ref="ViweTableRef" :loadingTable="loadingTable" @onRowClick="onRowClick" colnum=522 :tableData="tableData" :headerData="headerData" height="100%">
          </Commontable>
          <div class="pagination">
            <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total" :pageSize="pageSize"></Pagination>
          </div>
        </div>
      </div>
    </DialogFrom>
  </div>
</template>

<script>
import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
import CommonBtngroup from '@/components/commongroup.vue'
import DialogFrom from '@/components/dialog-from.vue'
import SearchComm from '@/components/comm-from-search.vue'
import Commontable from '@/components/common-table.vue'
import Pagination from '@/components/pagination.vue'
import headerData from '../headerData/headerData'
import { CustomerList, GetProvince, InventoryClassList } from '@/api/home'
import { HelperAreaMan, HelperRegionMan, HelperSalesMan } from '@/api/channel'

export default {
  components: {
    FromComm,
    CommonBtngroup,
    DialogFrom,
    SearchComm,
    Commontable,
    Pagination
  },
  props: {
    FromArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    right: {
      type: Number,
      default: 18
    }
  },
  data() {
    return {
      dialogVisibDialog: false,
      loadingTable: false,
      headerData: [],
      tableData: [],
      TableDataok: [],
      TableDataCusCodeok: [],
      TableDataAll: [],
      CusName: '',
      total: 0,
      pageIndex: 1,
      pageSize: 10
    }
  },
  created() { },
  mounted() {
    this.headerData = JSON.parse(JSON.stringify(headerData))
    this.inventoryClassList();
    this.HelperAreaMan();
    this.HelperRegionMan();
    this.HelperSalesMan();
  },
  activated() { },
  updated() { },
  methods: {
    // 列表
    async customerList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code,
        message
      } = await CustomerList({
        cusName: this.CusName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      //console.log(code, data)
      if (code == 0) {
        this.dialogVisibDialog = true
        // this.$refs.ViweTableRef.$refs.fileTable.toggleRowSelection(this.TableDataok);
        this.total = data.Count
        this.tableData = data.data

      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 产品线下拉
    async inventoryClassList() {
      let {
        code,
        data
      } = await InventoryClassList({

      })
      if (code == 0) {
        this.FromArr[0].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.InvClass,
            value: item.InvClassName
          }
          this.FromArr[0].options.push(obj)
        })
      }
    },
    // 三级销售
    async HelperRegionMan(ParentUserName) {
      let {
        code,
        data,
        message
      } = await HelperRegionMan({
        ParentUserName: ParentUserName
      })
      if (code == 0) {
        this.FromArr[2].options = []
        data.map((item, index) => {
          let obj = {
            key: item.key,
            value: item.value
          }
          this.FromArr[2].options.push(obj)
        })
      }
    },
    // 二级销售
    async HelperAreaMan(InvClass) {
      let {
        code,
        data,
        message
      } = await HelperAreaMan({
        InvClass: InvClass
      })
      if (code == 0) {
        this.FromArr[1].options = []
        data.map((item, index) => {
          let obj = {
            key: item.key,
            value: item.value
          }
          this.FromArr[1].options.push(obj)
        })
      }
    },
    // 销售员
    async HelperSalesMan(ParentUserName) {
      let {
        code,
        data,
        message
      } = await HelperSalesMan({
        ParentUserName: ParentUserName
      })
      if (code == 0) {
        this.FromArr[3].options = []
        data.map((item, index) => {
          let obj = {
            key: item.key,
            value: item.value
          }
          this.FromArr[3].options.push(obj)
        })
      }
    },

    searchClick(val) {
      this.pageIndex = 1
      this.CusName = val
      this.customerList()
    },
    cancelDialog() {
      this.dialogVisibDialog = false
    },
    dialogOKDialog() {
      if (this.TableDataAll.length > 0) {
        this.TableDataok = []
        this.TableDataCusCodeok = []
        this.TableDataAll.forEach((item, index) => {
          this.TableDataok.push(item.CusName)
          this.TableDataCusCodeok.push(item.CusCode)
        })
      } else {
        this.TableDataok = []
        this.TableDataCusCodeok = []
      }
      console.log(this.TableDataok, this.TableDataCusCodeok);
      this.$nextTick(() => {
        this.TableDataok.length > 0 ? this.FromArr[4].modelvalue = this.TableDataok.join(",") : this.FromArr[4].modelvalue = ""
        this.TableDataCusCodeok.length > 0 ? this.FromArr[4].key = this.TableDataCusCodeok.join(",") : this.FromArr[4].key = ""
      })
      console.log(this.FromArr[4]);
      this.dialogVisibDialog = false
    },
    distributorChange(e) {
      this.customerList()
    },
    invClassChange(e) {
      this.HelperAreaMan(e.FromArr[0].modelvalue)
      this.FromArr.forEach((item, index) => {
        if (index == 1 || index == 2 || index == 3) {
          item.modelvalue = ''
        }
      })
    },
    LargeArea(e) {
      this.HelperRegionMan(e.FromArr[1].modelvalue.join(","))
      this.FromArr.forEach((item, index) => {
        if (index == 2 || index == 3) {
          item.modelvalue = ''
        }
      })
    },
    ThirdDealerChange(e) {
      this.HelperSalesMan(e.FromArr[2].modelvalue.join(","))
      this.FromArr.forEach((item, index) => {
        if (index == 3) {
          item.modelvalue = ''
        }
      })
    },
    showclick() {

    },
    hide() {

    },
    select() {
      this.$emit("select")
    },
    reset() {
      this.FromArr.forEach((item, index) => {
        if (index == 5) {
          item.StartTime = ''
          item.EndTime = ''
        }
        item.modelvalue = ''
      })
    },
    onRowClick(row) {

    },
    handleSelectionChange(val) {
      this.TableDataAll = val
      console.log(val, this.TableDataAll);
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.customerList()
    },
    handleSizeChange(pageSize) {
      this.pageSize = PageSize
      this.customerList()
    },
  },
  computed: {},
  watch: {
    // 限制选择时间
    'FromArr.5.StartTime': {
      handler(n, o) {
        this.FromArr[5].EndTime = ''
        n ? this.FromArr[5].EndDisabled = false : this.FromArr[5].EndDisabled = true
      },
      deep: true
    },
    dialogVisibDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          for (let i = 0; i < this.TableDataAll.length; i++) {
            this.$nextTick(() => {
              this.$refs.choiceObjectTableleftTop.$refs.fileTableSelect.toggleRowSelection(this.TableDataAll[i], true);
            })
          }
        }
      }
    }
  },
}
</script>
<style scoped lang='less'>
.FormView {
  width: 100%;
  // height: 100px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  margin-top: 10px;
  padding-bottom: 20px;
  position: relative;

  .btngroup {
    position: relative;
    overflow: hidden;
    // bottom: 20px;
    // right: 20px;
  }
}

.DialogFrom {
  width: 100%;
  height: 505px;
  position: relative;
  overflow-y: scroll;
}
.search {
  position: relative;
  left: -43px;
}
.table {
  width: 85%;
  position: relative;
  top: 70px;
  left: 55px;
}
</style>